// extracted by mini-css-extract-plugin
export default {"heading":"lz-z","corrected":"mz-z","redirectVerbiageContainer":"nz-z","redirectVerbiageText":"oz-z"};